module.exports = __webpack_public_path__ + "assets/img/megaphone.3fca93e1.svg";